import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useData } from 'resift';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import makeDeleteEntity from 'fetches/makeDeleteEntity';
import makeGetEntitiesListFetch, { EntitiesRequestQuery } from 'fetches/makeGetEntitiesListFetch';
import * as Types from 'pages/Pages/typings';

import PagesTab from './PagesTab';

interface Props {
  entityType: Types.EntityType;
  migrationInProgress: boolean;
  onReload: () => void;
}

function Container({ entityType, migrationInProgress, onReload }: Props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const search = location.search;

  // entities list
  const makeGetEntitiesList = makeGetEntitiesListFetch();
  const pagesData = useData(makeGetEntitiesList);

  // delete:
  const deleteEntity = makeDeleteEntity();

  const handleDeleteEntity = async (entityId: string) => {
    await dispatch(deleteEntity(entityId));
    dispatch(makeGetEntitiesList({ query: { entityTypeId: entityType.id } }));
  };

  useEffect(() => {
    const query = queryString.parse(search) as Partial<EntitiesRequestQuery>;
    const searchQuery: EntitiesRequestQuery = {
      ...query,
      nameQuery: _get(query, 'q'),
      entityTypeId: entityType.id,
    };
    if (!migrationInProgress && entityType.id) {
      dispatch(makeGetEntitiesList({ query: searchQuery }));
    }
  }, [search, migrationInProgress, entityType.id]);

  return (
    <PagesTab
      hasQuery={search.length > 0}
      entityType={entityType}
      migrationInProgress={migrationInProgress}
      pagesData={pagesData}
      onDeleteEntity={handleDeleteEntity}
      onReload={onReload}
    />
  );
}

export default Container;
